module.exports = __webpack_public_path__ + "static/media/DropdownV2.25dc6ceb.css";